import type React from 'react';
import { cn } from '@/lib/utils';
import { OrderStatusLabels, OrderStatusColors } from '@/types/enums';
import type { OrderStatus } from '@/types/enums';

interface OrderStatusBadgeProps {
  status: OrderStatus;
  className?: string;
  size?: 'sm' | 'md';
}

const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({ status, className, size = 'sm' }) => {
  const sizeClasses = {
    sm: 'px-2.5 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium',
        OrderStatusColors[status],
        sizeClasses[size],
        className,
      )}
    >
      {OrderStatusLabels[status]}
    </span>
  );
};

export default OrderStatusBadge;
